import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../_services';
import { User } from '../_models';
import { Router } from '@angular/router';
@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerComponent implements OnInit {

  constructor(private authenticationService: AuthenticationService, private router: Router) { }
  user: any;
  selectedAction: number = 1;//1:profile 2:orders 3:logout
  ngOnInit(): void {

    this.user = this.authenticationService.currentUser;
  }
  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
  changeSelectedAction(item) {
    this.selectedAction = item;
    if (this.selectedAction == 2)
      this.getOrders();
  }
  allOrders: any;
  getOrders() {
    this.authenticationService.getUserOrders().subscribe(response => {
      this.allOrders = response.data;
    });
  }
}
